







































import { Component, Vue } from "vue-property-decorator";
import MyButton from "./../../components/MyButton.vue";
import "@/assets/sass/main.scss";
import Games, { GameSubject } from "../../components/Games.vue";

@Component({
  components: {
    MyButton,
    Games
  }
})
export default class Top extends Vue {
  public greetText?: string;
  public developGames: GameSubject[] = [
    { id: 1, title: "サンドボックス", details: "開発中のものをおいておいたりするページ", url: "//sandbox.tro-crafts.com/" }
  ];
  public archiveGames: GameSubject[] = [
    { id: 1, title: "ポケットブックオンライン", details: "小規模でチープなオンラインRPGの復刻版", url: "//pbo.tro-crafts.com/" }
  ];
  public oldGames: GameSubject[] = [
    { id: 1, title: "ゆるがるどの鐘", details: "クォータービューで楽しむオンラインRPG", url: "//yrgrd.tro-crafts.com/" },
    { id: 2, title: "ポケットブックオンライン", details: "小規模でチープなオンラインRPG", url: "//pbo.tro-crafts.com/" }
  ];

  created() {
    console.log("created");
    this.greetText = "AAA";
  }

  mounted() {
    console.log("mounted");
  }

  updated() {
    console.log("updated");
  }

  destroyed() {
    console.log("destroyed");
  }

  public onMyButtonClicked() {
    this.greetText = "こんにちは";
  }
}
